import React from 'react';
import { Box, Typography } from '@mui/material';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import useMisDashboardFilters from '../hooks/useMisDashboardFilters';
import { useGetMisFilterOptionsHandler } from '../dataHandlers/getMisFilterOptionsHandler';
import MisDashboardFilterBar from '../components/MisDashboardFilterBar';
import MisDashboardTabs from '../components/MisDashboardTabs';

export default function MisDashboardPage() {
  const { misDashboard: m } = useTranslatedMessages();
  useDocumentTitle(m.page_title ?? 'MIS Dashboard');

  const { filters, setFilter, patchFilters, clearAll, queryParams } = useMisDashboardFilters();
  const { filterOptions, isLoading: optionsLoading } = useGetMisFilterOptionsHandler();

  return (
    <Box sx={{ px: { xs: 1, md: 2 }, py: 3, maxWidth: 1280, mx: 'auto', width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {m.page_title ?? 'MIS Dashboard'}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {m.page_subtitle ?? 'Monitor compliance, VAT, and intra-company performance'}
        </Typography>
      </Box>

      <MisDashboardFilterBar
        filters={filters}
        setFilter={setFilter}
        patchFilters={patchFilters}
        clearAll={clearAll}
        filterOptions={filterOptions}
        loading={optionsLoading}
      />

      <MisDashboardTabs queryParams={queryParams} />
    </Box>
  );
}
